import User from '@/models/User'

const state = {
  user: null,
  isSettingCurrentUser: false
}

const mutations = {
  logout (state) {
    state.user = null
  },
  setCurrentUser (state, user) {
    state.user = user
  },
  isSettingCurrentUser (state, boolean) {
    state.isSettingCurrentUser = boolean
  }
}

const getters = {
  currentUser (state) {
    return state.user
  },
  isSettingCurrentUser (state) {
    return state.isSettingCurrentUser
  }
}

const actions = {

  logout ({ commit }) {
    commit('logout')
  },

  setCurrentUser ({ commit }) {
    commit('isSettingCurrentUser', true)
    return User.fromToken(localStorage.token).then(user => {
      commit('setCurrentUser', user)
      commit('isSettingCurrentUser', false)
      // Turning off 1/22/21
      // if (process.env.NODE_ENV !== 'development') {
      //   this._vm.$intercom.boot({
      //     user_id:        user.id,
      //     name:           user.fullName(),
      //     email:          user.emailAddress,
      //     sign_up_date:   user.createdAt
      //   })
      //   this._vm.$intercom.show()
      // }
    }).catch((error) => {
      commit('setCurrentUser', null)
      return Promise.reject(error)
    })
  },

  resetCurrentUser (context, user) {
    context.commit('setCurrentUser', User.fromObject(user))
  },

  isSettingCurrentUser ({ commit }) {

  }

}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js